export const turnOffSelectEvent = () => {
  document.body.onselectstart = null;
};

export const turnOnSelectEvent = () => {
  document.body.onselectstart = function () {
    return false;
  };
};
